export default "__VITE_ASSET__lZ9aT3S5__"